// Legacy fleet rollup + tenant-devices + device-detail drill-down,
// extracted verbatim from App.tsx as part of B.1.5 Task 1. The shape
// (useState-driven drill-down, no per-page routing) is preserved on
// purpose — B.1.5 explicitly does NOT migrate the fleet view to
// nested routes; that's a later sub-project.

import { useState } from "react";
import { useQuery } from "@tanstack/react-query";

import { api } from "../../api/client";
import type { TenantSummary } from "../../api/types";
import { DeviceDetailView } from "../../components/DeviceDetailView";
import { TenantDevicesView } from "../../components/TenantDevicesView";
import { TenantTile } from "../../components/TenantTile";

export function FleetPage() {
  const [selectedTenant, setSelectedTenant] = useState<TenantSummary | null>(null);
  const [selectedDeviceId, setSelectedDeviceId] = useState<number | null>(null);

  const tenantsQuery = useQuery({
    queryKey: ["tenants"],
    queryFn: api.tenants,
  });

  if (selectedTenant && selectedDeviceId !== null) {
    return (
      <DeviceDetailView
        tenantSlug={selectedTenant.slug}
        tenantDisplayName={selectedTenant.display_name}
        deviceId={selectedDeviceId}
        onBack={() => setSelectedDeviceId(null)}
      />
    );
  }
  if (selectedTenant) {
    return (
      <TenantDevicesView
        tenantSlug={selectedTenant.slug}
        tenantDisplayName={selectedTenant.display_name}
        onBack={() => {
          setSelectedTenant(null);
          setSelectedDeviceId(null);
        }}
        onDeviceClick={(device) => {
          if (device.device_id !== null) setSelectedDeviceId(device.device_id);
        }}
      />
    );
  }

  return (
    <section>
      <h2 style={{ margin: "0 0 16px", fontSize: "1.1rem", color: "var(--text-dim)" }}>
        Fleet rollup
      </h2>
      {tenantsQuery.isLoading && <p style={{ color: "var(--text-dim)" }}>Loading tenants…</p>}
      {tenantsQuery.error && (
        <p style={{ color: "var(--crit)" }}>
          Failed to load tenants: {String(tenantsQuery.error)}
        </p>
      )}
      {tenantsQuery.data && (
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))",
            gap: 16,
          }}
        >
          {tenantsQuery.data.map((tenant) => (
            <TenantTile
              key={tenant.slug}
              tenant={tenant}
              onClick={() => setSelectedTenant(tenant)}
            />
          ))}
        </div>
      )}
    </section>
  );
}
